import {GroupedFacilities} from 'types/Hotel'

/**
 * Calculate the total length of facilities in an array of grouped facilities.
 * @param arrays - An array of GroupedFacilities objects.
 * @returns - The total length of facilities in the provided arrays.
 */
export const getTheListLength = (arrays: GroupedFacilities[]) =>
  arrays.reduce((acc, str) => acc + str.facilities.length, 0)

/**
 * Distribute an array of grouped facilities into two columns based on total facility length.
 * @param arrays - An array of GroupedFacilities objects to distribute.
 * @returns - An object with two columns: firstColumn and secondColumn.
 */
export const getDistributeColumns = (arrays: GroupedFacilities[]) => {
  const groupedItems = Array.isArray(arrays)
    ? [...arrays].filter(item => item?.facilities?.length > 0)
    : []

  // Sort the groups by the total facility length in descending order.
  groupedItems.sort((a, b) => {
    const sumA = a.facilities.reduce((acc, str) => acc + str.length, 0)
    const sumB = b.facilities.reduce((acc, str) => acc + str.length, 0)
    return sumB - sumA
  })

  const firstList: GroupedFacilities[] = []
  const secondList: GroupedFacilities[] = []

  // Distribute groups into columns with the least total length.
  groupedItems.forEach(item => {
    const firstListLength = getTheListLength(firstList)
    const secondListLength = getTheListLength(secondList)

    if (secondListLength >= firstListLength) {
      firstList.push(item)
    } else {
      secondList.push(item)
    }
  })

  // Determine the order of columns based on total length.
  if (getTheListLength(secondList) > getTheListLength(firstList))
    return {firstColumn: secondList, secondColumn: firstList}

  return {firstColumn: firstList, secondColumn: secondList}
}
